module.exports = __webpack_public_path__ + "img/card1.7658c5e.png";